<div class="gauge">
  <div class="index" *ngFor="let value of indexes;">{{value}}</div>
  <h2 class="title">{{title}}</h2>
  <h2 class="unit">{{unit}}</h2>
  <h3 class="subtitle" *ngIf="average">AVG:{{average}}</h3>
  <h3 class="subtitle" *ngIf="max">MAX:{{max}}</h3>
</div>
<div *ngIf="maxAngle" class="redneedle" [style.transform]="'rotate('+maxAngle+'deg)'"></div>
<div class="needle" [style.transform]="'rotate('+angle+'deg)'"></div>
